import React from 'react';

import classNames from 'classnames';
import { OverlayTrigger, Popover, Button, Tooltip } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faColumns } from '@fortawesome/pro-regular-svg-icons';

interface Props {
  className?: string;
  children: React.ReactNode;
  hide?: boolean;
  onClose?: () => void;
  onOpen?: () => void;
}

// NOTE: Mostly copied from an existing, old component - don't use this as an example of best practices
export default function ColumnSelectorButton({
  className,
  children,
  hide,
  onOpen,
  onClose,
}: Props) {
  return (
    <div className={classNames('d-none', 'd-lg-block', className)}>
      <OverlayTrigger
        overlay={
          <Popover id="popover-positioned-bottom">
            <Popover.Body className="columns-selector-body">
              {children}
            </Popover.Body>
          </Popover>
        }
        placement="bottom"
        rootClose
        show={hide}
        trigger="click"
        onToggle={(state) => {
          if (!state && onClose) {
            onClose();
          }
          if (state && onOpen) {
            onOpen();
          }
        }}
      >
        <span className="d-inline-block">
          <OverlayTrigger
            overlay={<Tooltip>Manage Columns</Tooltip>}
            trigger={['hover', 'focus']}
          >
            <Button className="btn-icon" variant="outline" onClick={onOpen}>
              <FontAwesomeIcon icon={faColumns} />
              <span className="visually-hidden">Manage Columns</span>
            </Button>
          </OverlayTrigger>
        </span>
      </OverlayTrigger>
    </div>
  );
}
